import React from 'react';
import { useAudio, useAudioTime } from '../../../../contexts';
import { colorsMapper } from '../../AudioPlayer.utils';
import { AudioThumb } from './components/AudioThumb/AudioThumb';
import { getPercentage } from './components/AudioThumb/utils';
import { Header } from './components/Header/Header';
import * as S from './styled';
export var AudioBar = function AudioBar(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '0%' : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'green' : _ref$color,
      hideTime = _ref.hideTime;

  var _useAudio = useAudio(),
      duration = _useAudio.duration,
      seek = _useAudio.seek;

  var _useAudioTime = useAudioTime(),
      currentTime = _useAudioTime.currentTime;

  var handleOnClick = function handleOnClick(e) {
    var _e$currentTarget$getB = e.currentTarget.getBoundingClientRect(),
        left = _e$currentTarget$getB.left,
        width = _e$currentTarget$getB.width;

    var x = e.clientX - left; // x position within the bar element.

    seek(x / width * duration);
  };

  return /*#__PURE__*/React.createElement(S.Wrapper, {
    flexDirection: "column",
    width: "100%",
    disabled: !duration
  }, !hideTime && /*#__PURE__*/React.createElement(Header, {
    duration: duration,
    currentTime: currentTime
  }), /*#__PURE__*/React.createElement(AudioThumb, {
    currentTime: currentTime,
    height: height,
    color: colorsMapper[color]
  }, /*#__PURE__*/React.createElement(S.Bar, {
    value: getPercentage(currentTime, duration),
    fillerColor: colorsMapper[color],
    onClick: handleOnClick,
    "data-test": "bar"
  })));
};